import SvgApp from '@img/icons/app.svg';
import SvgArrowRight from '@img/icons/arrow-right.svg';
import SvgBorrowMoney from '@img/icons/borrow-money.svg';
import SvgCalculator from '@img/icons/calculator.svg';
import SvgChevronDown from '@img/icons/chevron-down.svg';
import SvgClock from '@img/icons/clock.svg';
import SvgClose from '@img/icons/close.svg';
import SvgDelete from '@img/icons/delete.svg';
import SvgDocument from '@img/icons/document.svg';
import SvgEdit from '@img/icons/edit.svg';
import SvgEmail from '@img/icons/email.svg';
import SvgFaq from '@img/icons/faqs.svg';
import SvgHouseSimple from '@img/icons/house-simple.svg';
import SvgHouse from '@img/icons/house.svg';
import SvgInterestRates from '@img/icons/interest-rates.svg';
import SvgList from '@img/icons/list.svg';
import SvgLocation from '@img/icons/location.svg';
import SvgMenu from '@img/icons/menu.svg';
import SvgMinus from '@img/icons/minus.svg';
import SvgPhone from '@img/icons/phone.svg';
import SvgPlus from '@img/icons/plus.svg';
import SvgQuote from '@img/icons/quote.svg';
import SvgSavings from '@img/icons/savings.svg';
import SvgSearch from '@img/icons/search.svg';
import SvgSendEmail from '@img/icons/send-email.svg';
import SvgSpeechBubble from '@img/icons/speech-bubble.svg';
import SvgStar from '@img/icons/star.svg';
import SvgSummary from '@img/icons/summary.svg';
import SvgTick from '@img/icons/tick.svg';
import SvgUser from '@img/icons/user.svg';
import SvgWarning from '@img/icons/warning.svg';
import * as React from 'react';
import { PuffLoader } from 'react-spinners';
// @todo: Map rest of the icons when confirmed
export var SystemIcon;
(function (SystemIcon) {
    SystemIcon["App"] = "app";
    SystemIcon["ArrowRight"] = "arrow-right";
    SystemIcon["ArrowDown"] = "arrow-down";
    SystemIcon["BorrowMoney"] = "borrow-money";
    SystemIcon["Calculator"] = "calculator";
    SystemIcon["ChevronDown"] = "chevron-down";
    SystemIcon["Clock"] = "clock";
    SystemIcon["Close"] = "close";
    SystemIcon["Delete"] = "delete";
    SystemIcon["Document"] = "document";
    SystemIcon["Edit"] = "edit";
    SystemIcon["Email"] = "email";
    SystemIcon["Faq"] = "faq";
    SystemIcon["House"] = "house";
    SystemIcon["HouseSimple"] = "house-simple";
    SystemIcon["InterestRates"] = "interest-rates";
    SystemIcon["List"] = "list";
    SystemIcon["Loader"] = "loader";
    SystemIcon["Location"] = "location";
    SystemIcon["Menu"] = "menu";
    SystemIcon["Minus"] = "minus";
    SystemIcon["None"] = "none";
    SystemIcon["Phone"] = "phone";
    SystemIcon["Plus"] = "plus";
    SystemIcon["Quote"] = "quote";
    SystemIcon["Savings"] = "savings";
    SystemIcon["Search"] = "search";
    SystemIcon["SendEmail"] = "send-email";
    SystemIcon["SpeechBubble"] = "speech-bubble";
    SystemIcon["Star"] = "star";
    SystemIcon["Summary"] = "summary";
    SystemIcon["Tick"] = "tick";
    SystemIcon["User"] = "user";
    SystemIcon["Warning"] = "warning";
})(SystemIcon || (SystemIcon = {}));
export const getSystemIcon = (icon) => {
    switch (icon) {
        case SystemIcon.App:
            return React.createElement(SvgApp, null);
        case SystemIcon.ArrowDown:
        case SystemIcon.ArrowRight:
            return React.createElement(SvgArrowRight, null);
        case SystemIcon.BorrowMoney:
            return React.createElement(SvgBorrowMoney, null);
        case SystemIcon.Calculator:
            return React.createElement(SvgCalculator, null);
        case SystemIcon.ChevronDown:
            return React.createElement(SvgChevronDown, null);
        case SystemIcon.Clock:
            return React.createElement(SvgClock, null);
        case SystemIcon.Close:
            return React.createElement(SvgClose, null);
        case SystemIcon.Delete:
            return React.createElement(SvgDelete, null);
        case SystemIcon.Document:
            return React.createElement(SvgDocument, null);
        case SystemIcon.Edit:
            return React.createElement(SvgEdit, null);
        case SystemIcon.Email:
            return React.createElement(SvgEmail, null);
        case SystemIcon.Faq:
            return React.createElement(SvgFaq, null);
        case SystemIcon.House:
            return React.createElement(SvgHouse, null);
        case SystemIcon.HouseSimple:
            return React.createElement(SvgHouseSimple, null);
        case SystemIcon.InterestRates:
            return React.createElement(SvgInterestRates, null);
        case SystemIcon.List:
            return React.createElement(SvgList, null);
        case SystemIcon.Loader:
            return React.createElement(PuffLoader, { color: "currentColor", size: 17 });
        case SystemIcon.Location:
            return React.createElement(SvgLocation, null);
        case SystemIcon.Menu:
            return React.createElement(SvgMenu, null);
        case SystemIcon.Minus:
            return React.createElement(SvgMinus, null);
        case SystemIcon.Phone:
            return React.createElement(SvgPhone, null);
        case SystemIcon.Plus:
            return React.createElement(SvgPlus, null);
        case SystemIcon.Quote:
            return React.createElement(SvgQuote, null);
        case SystemIcon.Savings:
            return React.createElement(SvgSavings, null);
        case SystemIcon.Search:
            return React.createElement(SvgSearch, null);
        case SystemIcon.SendEmail:
            return React.createElement(SvgSendEmail, null);
        case SystemIcon.SpeechBubble:
            return React.createElement(SvgSpeechBubble, null);
        case SystemIcon.Star:
            return React.createElement(SvgStar, null);
        case SystemIcon.Summary:
            return React.createElement(SvgSummary, null);
        case SystemIcon.Tick:
            return React.createElement(SvgTick, null);
        case SystemIcon.User:
            return React.createElement(SvgUser, null);
        case SystemIcon.Warning:
            return React.createElement(SvgWarning, null);
        default:
            return null;
    }
};
export const PinSVG = `<svg width="86" height="98" viewBox="0 0 86 98" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M43 79C34.9429 72.8824 28.9286 66.9412 24.9571 61.1765C20.9857 55.4118 19 49.7647 19 44.2353C19 40.0588 19.7286 36.3971 21.1857 33.25C22.6429 30.1029 24.5143 27.4706 26.8 25.3529C29.0857 23.2353 31.6571 21.6471 34.5143 20.5882C37.3714 19.5294 40.2 19 43 19C45.8 19 48.6286 19.5294 51.4857 20.5882C54.3429 21.6471 56.9143 23.2353 59.2 25.3529C61.4857 27.4706 63.3571 30.1029 64.8143 33.25C66.2714 36.3971 67 40.0588 67 44.2353C67 49.7647 65.0143 55.4118 61.0429 61.1765C57.0714 66.9412 51.0571 72.8824 43 79Z" fill="#2FB457"/>
<path d="M43.0034 36.2029C35.5984 36.2029 29.6016 39.6769 29.6016 43.9757C29.6016 46.4999 31.6653 48.7493 34.8701 50.1739C35.477 53.6229 32.952 54.8475 32.952 54.8475C32.952 54.8475 35.2342 55.9722 38.3662 53.6729C39.3859 52.9231 39.8958 52.0983 40.1385 51.5735C41.0611 51.6984 42.0323 51.7484 43.0277 51.7484C50.4327 51.7484 56.4296 48.2744 56.4296 43.9757C56.4053 39.6769 50.4085 36.2029 43.0034 36.2029Z" fill="#2FB457"/>
<path d="M28.8477 43.9761C28.8477 46.6503 30.79 49.0746 34.189 50.6742C34.6503 53.6233 31.4698 54.748 31.4698 54.748C31.4698 54.748 34.6988 57.4972 38.802 54.2982C39.6517 53.6483 40.2101 52.9735 40.55 52.3987C41.3755 52.4737 42.1767 52.5487 43.0022 52.5487C50.9413 52.5487 57.1567 48.7747 57.1567 43.9761C57.1567 39.1775 50.9413 35.4036 43.0022 35.4036C35.063 35.4286 28.8477 39.1775 28.8477 43.9761ZM35.7185 51.199C35.7185 50.8242 35.6943 50.4493 35.6214 50.0244L35.5486 49.6245L35.1844 49.4495C32.1738 48.0999 30.3772 46.0755 30.3772 43.9761C30.3772 40.1772 36.1798 36.9781 43.0265 36.9781C49.8731 36.9781 55.6757 40.1772 55.6757 43.9761C55.6757 47.775 49.8731 50.9741 43.0265 50.9741C42.1039 50.9741 41.157 50.9241 40.2344 50.7992L39.7003 50.7242L39.4575 51.224C39.239 51.6739 38.8019 52.3737 37.9279 53.0235C36.6169 53.9982 35.5 54.2732 34.6988 54.3231C35.2573 53.5984 35.7185 52.5737 35.7185 51.199Z" fill="white"/>
<path d="M43.0034 36.2029C35.5984 36.2029 29.6016 39.6769 29.6016 43.9757C29.6016 46.4999 31.6653 48.7493 34.8701 50.1739C35.477 53.6229 32.8792 54.7726 32.8792 54.7726C32.8792 54.7726 35.2342 55.9972 38.3419 53.6729C39.3616 52.9231 39.8715 52.0983 40.1143 51.5735C41.0369 51.6984 42.008 51.7484 43.0034 51.7484C50.4085 51.7484 56.4053 48.2744 56.4053 43.9757C56.4053 39.6769 50.4085 36.2029 43.0034 36.2029Z" fill="white"/>
</svg>`;
export const PinSVGSelected = `<svg width="86" height="98" viewBox="0 0 86 98" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M43 79C34.9429 72.8824 28.9286 66.9412 24.9571 61.1765C20.9857 55.4118 19 49.7647 19 44.2353C19 40.0588 19.7286 36.3971 21.1857 33.25C22.6429 30.1029 24.5143 27.4706 26.8 25.3529C29.0857 23.2353 31.6571 21.6471 34.5143 20.5882C37.3714 19.5294 40.2 19 43 19C45.8 19 48.6286 19.5294 51.4857 20.5882C54.3429 21.6471 56.9143 23.2353 59.2 25.3529C61.4857 27.4706 63.3571 30.1029 64.8143 33.25C66.2714 36.3971 67 40.0588 67 44.2353C67 49.7647 65.0143 55.4118 61.0429 61.1765C57.0714 66.9412 51.0571 72.8824 43 79Z" fill="#002240"/>
<path d="M34 55L43 46M43 46L52 37M43 46L34 37M43 46L52 55" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
export const LocationIcon = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.0018 11.8652C12.4993 11.8652 12.9246 11.6881 13.2778 11.3338C13.6311 10.9794 13.8078 10.5535 13.8078 10.056C13.8078 9.5585 13.6306 9.13308 13.2763 8.77975C12.9219 8.42658 12.4959 8.25 11.9983 8.25C11.5008 8.25 11.0754 8.42717 10.7223 8.7815C10.3689 9.13583 10.1923 9.56183 10.1923 10.0595C10.1923 10.557 10.3694 10.9823 10.7238 11.3355C11.0781 11.6887 11.5041 11.8652 12.0018 11.8652ZM12 19.5135C13.9564 17.7622 15.4534 16.0823 16.4913 14.474C17.5291 12.8657 18.048 11.457 18.048 10.248C18.048 8.425 17.4689 6.92633 16.3105 5.752C15.1522 4.57767 13.7154 3.9905 12 3.9905C10.2847 3.9905 8.84786 4.57767 7.68953 5.752C6.53119 6.92633 5.95203 8.425 5.95203 10.248C5.95203 11.457 6.47094 12.8657 7.50878 14.474C8.54661 16.0823 10.0437 17.7622 12 19.5135ZM12 21.5095C9.48336 19.3288 7.59619 17.2994 6.33853 15.4212C5.08086 13.5429 4.45203 11.8185 4.45203 10.248C4.45203 7.94033 5.19844 6.07208 6.69128 4.64325C8.18428 3.21442 9.95386 2.5 12 2.5C14.0462 2.5 15.8158 3.21442 17.3088 4.64325C18.8016 6.07208 19.548 7.94033 19.548 10.248C19.548 11.8185 18.9192 13.5429 17.6615 15.4212C16.4039 17.2994 14.5167 19.3288 12 21.5095Z" fill="currentColor"/>
</svg>
`;
export const ArrowIcon = `<svg viewBox="4 4 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16.627 12.75H4.5V11.25H16.627L10.9308 5.55375L12 4.5L19.5 12L12 19.5L10.9308 18.4462L16.627 12.75Z" fill="currentColor"/>
</svg>
`;
